'use es6';

import { Record } from 'immutable';
import { AdAccountStatus } from './AdAccountRecord';
import { Networks } from 'AdsUI/lib/Constants';
import { formatAdWordsAccountId } from 'AdsUI/lib/Utils';

class AdAccountOverviewRecord extends Record({
  network: null,
  accountId: null,
  accountName: null,
  connectedAt: null,
  currencyCode: null,
  trackingEnabled: null,
  trackingSince: null,
  accessibleToPrimaryUser: null,
  paymentMethodIsMissing: null,
  primaryHubSpotUserId: null,
  primaryNetworkUserId: null,
  status: AdAccountStatus.ACTIVE,
  adAccountAssignees: null,
  adAccountFetchError: null,
  conversionTrackingInfo: null
}) {
  getDisplayName() {
    return this.network === Networks.ADWORDS ? this.getFormattedName() : this.getShortName();
  }

  getFormattedName() {
    const accountId = this.network === Networks.ADWORDS ? formatAdWordsAccountId(this.accountId) : this.accountId;
    return this.accountName ? `${this.accountName} (${accountId})` : accountId;
  }

  getShortName() {
    return this.network === Networks.ADWORDS && !this.accountName ? formatAdWordsAccountId(this.accountId) : this.accountName || this.accountId;
  }

  isValidForReporting(connectedUsers) {
    const primaryUserConnectedUser = connectedUsers.find(user => user.userId === this.primaryNetworkUserId && user.network === this.network);

    if (!primaryUserConnectedUser || !primaryUserConnectedUser.authenticated || primaryUserConnectedUser.isMissingManageScope()) {
      return false;
    }

    if (this.status !== AdAccountStatus.ACTIVE && this.status !== AdAccountStatus.UNKNOWN) {
      return false;
    }

    if (!this.accessibleToPrimaryUser) {
      return false;
    }

    return true;
  }

}

export default AdAccountOverviewRecord;